<template>
  <section>
    <ZDialog :show="isVisible" :modal-size="modalSize" :dStyle="'z-index: 1070'" :bdStyle="'z-index: 1065'">
      <template #header>
        <h4 class="modal-title">Edit AI Prompt Template</h4>
      </template>
      <template #body>
        <div class="row">
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">AI Name</span>
              <input type="text" id="aiName" v-model="modelValue.aiName" class="form-control"
                @keyup="isChanged = true" />
            </div>
          </div>
          <div class="col">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <textarea v-model="role" class="form-control" rows="2" placeholder="Enter the AI's Role here..."
              @keyup="isChanged = true" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col custom-body">
            <textarea ref="prompt" v-model="prompt" class="form-control" rows="22" placeholder="Enter AI Prompt here..."
              @keyup="isChanged = true" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="col">
          <div class="input-group">
            <span class="input-group-text">Key</span>
            <select id="aiKey" v-model="selectedKey" class="form-select" @change="selectKey()">
              <option v-for="(item, idx) in aiKeys" :key="idx" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col">
          <span>Place your cursor where you'd like the key to be inserted into the AI Prompt.</span>
        </div>
        <div class="col custom-right-align">
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="button" class="btn btn-primary" :class="{ 'btn-danger': isChanged }"
            @click="save()">Save</button>
        </div>
      </template>
    </ZDialog>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { aiStore } from '@/stores/ai'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'ai-edit-dialog',
  components: {
    ZDialog
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      isChanged: false,
      selectedKey: null
    }
  },
  computed: {
    ...mapState(aiStore, ['aiKeys']),
    isVisible() {
      return this.modelValue
    },
    role: {
      get() {
        return this.modelValue ? this.modelValue.aiRole : ''
      },
      set(value) {
        this.modelValue.aiRole = value
      }
    },
    prompt: {
      get() {
        return this.modelValue ? this.modelValue.prompt : ''
      },
      set(value) {
        this.modelValue.prompt = value
      }
    },
  },
  methods: {
    close() {
      this.isChanged = false
      this.$emit('close')
    },
    selectKey() {
      const textarea = this.$refs.prompt
      if (!textarea || !this.selectedKey) return

      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      const value = this.prompt

      // Insert selectedKey at cursor position
      this.prompt =
        value.substring(0, start) +
        this.selectedKey +
        value.substring(end)

      // Move the cursor just after the inserted text
      this.$nextTick(() => {
        textarea.focus()
        textarea.selectionStart = textarea.selectionEnd = start + this.selectedKey.length
      })

      // Optionally reset the select
      this.selectedKey = null
    },
    async save() {
      if (!this.modelValue || !this.modelValue.aiName) {
        alert('AI Name is required.')
        return
      }
      this.isChanged = false
      let data = null
      if (this.modelValue.action === 'new') {
        data = {
          ai: null,
          firm: this.modelValue.firm,
          aiName: this.modelValue.aiName,
          aiRole: this.modelValue.aiRole,
          aiModel: this.modelValue.aiModel,
          prompt: this.modelValue.prompt
        }
      } else {
        data = {
          ai: this.modelValue.ai,
          firm: this.modelValue.firm,
          aiName: this.modelValue.aiName,
          aiRole: this.modelValue.aiRole,
          aiModel: this.modelValue.aiModel,
          prompt: this.modelValue.prompt,
          fieldList: '|Firm|AIName|AIRole|AIModel|Prompt|'
        }
      }
      this.$emit('save', data)
    }
  }
}
</script>
<style scoped lang="scss">
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 560px;
  min-height: 560px;
}

.custom-footer {
  width: 100%;
  display: inline-flex;
}

.custom-right-align {
  text-align: right;
}
</style>
